<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="list"><a id="page_vii"></a><a href="#/xhtml/contents#list">List of Tables and Figures</a></p>
<table cellpadding="0" cellspacing="0" class="table">
<tbody><tr>
<td id="rt1"><a href="#/xhtml/chapter001#t1">Table 1</a></td>
<td style="padding-left:1em;"><a href="#/xhtml/chapter001#t1">Theological and philosophical reasons for disagreement and suggested cures</a></td>
</tr>
<tr>
<td id="rt2"><span href="#/xhtml/chapter002#t2" title="Link target outside of Sample">Table 2</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter002#t2" title="Link target outside of Sample">Two types of cognitive processing</span></td>
</tr>
<tr>
<td id="rt3"><span href="#/xhtml/chapter002#t3" title="Link target outside of Sample">Table 3</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter002#t3" title="Link target outside of Sample">McGilchrist’s model of cognition: the master and the emissary</span></td>
</tr>
<tr>
<td id="rt4"><span href="#/xhtml/chapter002#t4" title="Link target outside of Sample">Table 4</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter002#t4" title="Link target outside of Sample">Psychological reasons for disagreement and suggested cures</span></td>
</tr>
<tr>
<td id="rfig1"><a href="#/xhtml/introduction#fig1">Figure 1</a></td>
<td style="padding-left:1em;"><a href="#/xhtml/introduction#fig1">Disagreement and various types of inquiry</a></td>
</tr>
<tr>
<td id="rfig2"><span href="#/xhtml/chapter002#fig2" title="Link target outside of Sample">Figure 2</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter002#fig2" title="Link target outside of Sample">Stanovich’s model of the dual-process account</span></td>
</tr>
<tr>
<td id="rfig3"><span href="#/xhtml/chapter002#fig3" title="Link target outside of Sample">Figure 3</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter002#fig3" title="Link target outside of Sample">Haidt’s three ways of ethical deliberation</span></td>
</tr>
<tr>
<td id="rfig4"><span href="#/xhtml/chapter004#fig4" title="Link target outside of Sample">Figure 4</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter004#fig4" title="Link target outside of Sample">The process of debiasing</span></td>
</tr>
<tr>
<td id="rfig5"><span href="#/xhtml/chapter004#fig5" title="Link target outside of Sample">Figure 5</span></td>
<td style="padding-left:1em;"><span href="#/xhtml/chapter004#fig5" title="Link target outside of Sample">Bootstrapping</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?f99570e6